<template>
  <div>
    <Card class="cardData">
      <Card v-show="manualAlert.length" tile flat v-for="item in manualAlert" :key="item._id">
        <v-divider></v-divider>
        <v-layout row wrap pa-1>
          <v-flex md1 pl-3 pt-2>
          </v-flex>
          <v-flex md11 pa-2>
            <v-layout row wrap>
              <v-flex md3>
                <div class="try--text pt-1">{{item.equipment}}</div>
              </v-flex>
              <v-flex md9 text-xs-right>
                <div>
                  {{ $t('Created Time') }}{{ item.resolved_time ? ` - ${$t('Resolved Time')}` : '' }}
                </div>
                <div>
                  {{ item.created_time }}{{ item.resolved_time ? ` - ${ item.resolved_time }` : '' }}
                </div>
              </v-flex>
            </v-layout>
            <v-flex md12>
              <div class="subheading">{{ item['message'] }}</div>
            </v-flex>
          </v-flex>
        </v-layout>
      </Card>

      <v-layout v-show="!manualAlert.length" row justify-center align-center fill-height>
        <div>
          <v-icon size="50" color="accent">
            warning
          </v-icon>
        </div>
        <div class="no-alert">
          {{ $t('NO ALERTS') }}
        </div>
      </v-layout>
    </Card>
    <div class="pagination text-xs-center">
      <v-pagination v-show="totalPages > 1" v-model="currentPage" :length="totalPages"
        dark color="accent" :total-visible="8" prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right" circle></v-pagination>
    </div>
  </div>
</template>

<script>
import CommonApi from '@/services/Common'
import { mapGetters, mapMutations } from 'vuex'
import { mixin, mapGettersMixin } from '@/util/mixin/index'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import Alert from '@/services/Alert'

import { EventBus } from '@/services/event-bus'
const Graph = () => import('@/components/dashboard-inverter/Graph')
const SideCard = () => import('@/components/dashboard-inverter/SideCard')
var moment = require('moment')
const momentTz = require('moment-timezone')

Vue.use(ElementUI, { locale })

export default {
  mixins: [mixin, mapGettersMixin],
  data() {
    return {
      block_selected: null,
      inverter_room_list: [],
      manualAlert: [],
      currentPage: 1,
      totalItems: 10,
      totalOutput: null,
      isNext: false,
      value: null,
      loading: false
    }
  },
  components: {
    Graph,
    SideCard
  },
  computed: {
    ...mapGetters([
      'getActivePlantInfo',
      'getPlantId',
      'getSelectedPlantId',
      'getGeneralState'
    ]),
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    totalPages() {
      let pages = 0
      if (this.totalOutput) {
        pages = Math.floor(this.totalOutput / this.totalItems)
        if (this.totalOutput % this.totalItems > 0) {
          pages++
        }
      }
      return pages
    }
  },
  created() {
    EventBus.$on('graph-click', this.onManualAlert)
  },
  beforeDestroy() {
    this.SET_MAP_REDIRECT_BLOCK(false)
    EventBus.$off('graph-click', this.onManualAlert)
  },
  methods: {
    ...mapMutations(['SET_MAP_REDIRECT_BLOCK']),
    previous() {
      if (this.currentPage > 1) this.currentPage -= 1
    },
    next() {
      if (this.isNext) this.currentPage += 1
    },
    change(id) {
      this.block_selected = id
    },
    addLineBreak(message) {
      return message.replace(/\n/g, '<br />')
    },
    async getInverterRoomList() {
      if (this.getSelectedPlantId && this.block_selected) {
        let response = await CommonApi.getIdList(
          this.getSelectedPlantId,
          'inverter',
          2,
          this.block_selected
        )

        if (response.status === 200) {
          this.inverter_room_list = response.data.message
        }
      }
    },
    onManualAlert(value) {
      this.value = value
      const { from, to } = this.activeFilter.Date
      const clickArea = value.xAxisData[value.eventIndex]
      this.loading = true
      if (
        momentTz(to).tz(this.getActivePlantInfo("timezone")).format('YYYY-MM-DD') ===
        momentTz(from).tz(this.getActivePlantInfo("timezone")).format('YYYY-MM-DD')
      ) {
        Alert.getManualAlertListV2(
          this.getSelectedPlantId,
          'computed',
          'MA',
          'time',
          momentTz(`${to} ${clickArea}:00:00`,
            'YYYY-MM-DD HH:mm:ss').tz(this.getActivePlantInfo("timezone")).format('X'),
          momentTz(`${from} ${clickArea}:59:59`,
            'YYYY-MM-DD HH:mm:ss').tz(this.getActivePlantInfo("timezone")).format('X'),
          this.currentPage,
          this.totalItems
        )
          .then((res) => {
            this.manualAlert = res.data.result.finalOutput
            this.totalOutput = res.data.result.count
            this.isNext =
              this.currentPage * this.totalItems < res.data.result.count
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            console.log(err)
          })
      } else if (
        momentTz(to).tz(this.getActivePlantInfo("timezone")).format('YYYY-MM-DD') <
        momentTz(from).tz(this.getActivePlantInfo("timezone")).format('YYYY-MM-DD')
      ) {
        Alert.getManualAlertListV2(
          this.getSelectedPlantId,
          'computed',
          'MA',
          'date',
          moment(clickArea).format('YYYY-MM-DD'),
          null,
          this.currentPage,
          this.totalItems
        )
          .then((res) => {
            this.manualAlert = res.data.result.finalOutput
            this.totalOutput = res.data.result.count
            this.isNext =
              this.currentPage * this.totalItems < res.data.result.count
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            console.log(err)
          })
      }
    }
  },
  watch: {
    'activeFilter.Date': {
      handler() {
        this.manualAlert = []
      },
      deep: true
    },
    block_selected() {
      this.getInverterRoomList()
      this.$emit('update:invRoomList', this.inverter_room_list)
    },
    getSelectedPlantId() {
      this.block_selected = null
      this.currentPage = 1
      this.totalOutput = null
      this.manualAlert = []
    },
    totalOutput() {
      if (this.totalPages > 1) {
        document.querySelector('.cardData').style.height = '43rem'
      } else {
        document.querySelector('.cardData').style.height = '46rem'
      }
    },
    currentPage() {
      this.onManualAlert(this.value)
    }
  }
}
</script>

<style scoped>
.cardData {
  height: 46rem;
  overflow-x: hidden;
  overflow-y: auto;
}

.no-alert {
  font-size: 1.5rem;
  font-weight: bold;
}

@media (max-width: 600px) {
  .pa-2 {
    padding: 0px !important;
  }
}

.theme--dark {
  width: -webkit-fill-available;
}

@media only screen and (min-width: 320px) and (max-width: 600px) {
  .ag-sub-header {
    height: 50px !important;
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
  }

  .ag-priority {
    width: 125px !important;
  }

  .ag-plant-overview {
    padding-top: 15px !important;
  }

  .ag-graph {
    padding: 16px 5px !important;
  }

  .ag-room {
    text-align: center;
  }

  .block-content {
    /* background-color: #FFF !important; */
    padding: 16px 10px;
  }

  #e3 .sub-header,
  #e3 {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  .single-card .hoverable {
    border: none !important;
  }

  .ag-graph .layout .flex {
    padding: 4px !important;
  }

  .activeBlock {
    margin: 10px;
  }

  .notActive {
    margin: 10px;
    border-radius: 10px;
  }

  .ana-card {
    padding: 20px 12px !important;
  }
}
</style>
